import { render, staticRenderFns } from "./VentesRrtrClientsQteRapp.vue?vue&type=template&id=2bc229eb&scoped=true&"
import script from "./VentesRrtrClientsQteRapp.vue?vue&type=script&lang=js&"
export * from "./VentesRrtrClientsQteRapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc229eb",
  null
  
)

export default component.exports